export default "__VITE_ASSET__abc58fd1__"